import {IMessageData, ISyncStepStatus, ITableColumn} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import * as ko from "knockout";
import {_} from 'lodash';
import pubsub from "../../pubsub";
import {storeObservable} from "../../util/sessionstore";
import {global, lm} from "../../appContext";
import {nsSync} from "../../util/nsSync";
import {memoryStore} from "../../util/memorystore";
import {ICustomSyncStepStatus} from "./index";
import {REQUEST_MESSAGE} from "../../constants/Language";
import {createErrorMessage} from "../../util/misc";
import {moment} from 'moment';
import {nsTooltip} from "../../util/nsTooltip";
import {convertFromServerString} from "../../util/datetime";

export let template: string = statusHtml;
import SyncStatus = nsSync.SyncStatus;
import statusHtml from './status.html?raw';

export class viewModel {
    private reqGetStatus: PromiseRequest = global.getPromiseRequest("geteadmstatus");

    TABLE: ITableColumn[] = [
        {label: "Organisasjonsnavn", key: "orgname", sort: true},
        {label: "Synkroniseringssteg", key: "syncstepname", sort: true},
        {label: "Start", key: "$timestamp", sort: true},
        {label: "Resultat", key: "result", sort: true},
        {label: "Status", key: "halted", sort: true}
    ];

    sortcol: KnockoutObservable<string> = storeObservable("report.sort.column");
    asc: KnockoutObservable<boolean> = storeObservable("report.sort.direction");
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    data: KnockoutObservableArray<ICustomSyncStepStatus> = ko.observableArray<ICustomSyncStepStatus>([]);
    isReady: KnockoutObservable<boolean> = ko.observable(false);
    filterErrors: KnockoutObservable<boolean> = storeObservable("report.filter.errors");
    selectedOrg: KnockoutObservable<string | null> = ko.observable(null)
    searchKey: KnockoutObservable<string>;

    constructor() {
        this.searchKey = memoryStore.get("eAdmStatusSearchKey", "");
        this.request();
        pubsub.on(this, "getefeidestatus_removeCache", this.request.bind(this));
    }

    request() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.reqGetStatus
            .request({
                token: global.login.getToken()
            })
            .then((data: ISyncStepStatus[]) => {
                this.messageData(null);
                const clone = _.clone(data)
                    .map((item: ISyncStepStatus): ICustomSyncStepStatus => {
                        const _item = _.extend({$ago: null, $timestamp: null}, item);
                        if (_item.halted) {
                            _item.result = _item.result || lm.t("unknown");
                        }
                        if (_item.started) {
                            const m = convertFromServerString(_item.started);
                            _item.$timestamp = m.unix();
                            _item.$ago = m.fromNow();
                        } else {
                            _item.$timestamp = 0;
                            _item.$ago = lm.t("unknown");
                        }
                        return _item;
                    });
                this.data(clone);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }

    dataSorted = ko.pureComputed((): ISyncStepStatus[] => {
        const data = this.getSorted(this.getFiltered());
        return this.asc()
            ? data
            : data.reverse()
            ;
    });

    private getFiltered(): ISyncStepStatus[] {
        return this.data().filter((item: ISyncStepStatus) => {
            return !!["orgname", "syncstepname", "$timestamp", "result"].find((key: string) => {
                const v = this.getFilterValue(key, item);
                const val = String(v).toLowerCase();
                return val.indexOf(this.searchKey().toLowerCase()) > -1;
            });
        });
    }

    private getFilterValue(sortcol: string, item: ISyncStepStatus) {
        switch (sortcol) {
            case "$timestamp":
                return (<any>item)["$ago"];
            case "halted":
                return this.getStatusDefinition(item).message;
            default:
                return (<any>item)[sortcol];
        }
    }

    private getSorted(sorted: ISyncStepStatus[] = this.data()): ISyncStepStatus[] {
        if (this.filterErrors()) {
            sorted = _.filter(sorted, (item: ISyncStepStatus) => !!item.result);
        }
        return _.sortBy(sorted, (item: any) => this.getSortValue(this.sortcol(), item));
    }

    private getSortValue(sortcol: string, item: ISyncStepStatus): string | number {
        switch (sortcol) {
            case "halted":
                return [
                    SyncStatus.Unknown,
                    SyncStatus.Halted,
                    SyncStatus.Executing,
                    SyncStatus.Executed,
                ].indexOf(nsSync.getSyncStatus(item));
            default:
                return (<any>item)[sortcol];
        }
    }

    private static DATE_FORMAT = "HH:mm:ss D.MMM YYYY";

    getFormattedDuration(start: string, end: string) {
        const s = moment(start, "DD.MM.YYYY HH.mm.ss");
        const e = moment(end, "DD.MM.YYYY HH.mm.ss");
        const isDateSame = s.date() == e.date();
        const isMonthSame = s.month() == e.month();
        const isYearSame = s.year() == e.year();
        if (isDateSame && isMonthSame && isYearSame) {
            return s.format("DD.MM.YYYY") + " " + s.format("HH:mm:ss") + "-" + e.format("HH:mm:ss");
        }
        return s.format(viewModel.DATE_FORMAT) + "-" + e.format(viewModel.DATE_FORMAT);
    }

    getStatusDefinition(item: ISyncStepStatus) {
        return nsSync.getStatusDefinitionFromSyncStatus(item);
    }

    isRecent(start: string) {
        const s = moment(start, "DD.MM.YYYY HH.mm.ss");
        return moment().subtract(3, "days").isBefore(s);
    }

    strip(html: string) {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    onRowClick(item: ISyncStepStatus) {
        if (nsSync.getSyncStatus(item) == SyncStatus.Unknown) {
            global.snackbarData(createErrorMessage('an unknown error occured'))
            return
        }
        const orgnr = this.isSelectedOrg(item) ? null: item.orgnr;
        this.selectedOrg(orgnr);
    }

    private isSelectedOrg(item: ISyncStepStatus): boolean {
        return item.orgnr == this.selectedOrg();
    }

    private setOrgNr(orgnr: string) {
        global.login.setSelectedOrganizationById(orgnr)
        return true
    }

    private getTitle(obj: ISyncStepStatus) {
        const org = global.login.getOrganizationById(obj.orgnr);
        if (!org) {
            return
        }
        return lm.t(nsTooltip.getTitle_organization(org) ?? '')
    }
}
